import isNil from 'lodash/isNil'
import {
    CollectionServiceType, DeliveryServiceType,
    ProductTypeCQuote, TemperatureRange,
} from 'app/enums/label.enums'
import reduceEnumValues from 'app/utils/reduceEnumValues'

export const tempRangeProductTypeMap = {
    [TemperatureRange.C]: ProductTypeCQuote.VAL_1500XCOL,
    [TemperatureRange.CRT]: ProductTypeCQuote.VAL_1500XCRT,
}

export const getCollectionOptions = ({
    isGroupedLaneStatuses,
    destinationCollectionLtl,
}: {
    isGroupedLaneStatuses?: boolean,
    destinationCollectionLtl?: boolean,
}) => {
    return (isGroupedLaneStatuses || destinationCollectionLtl)
        ? reduceEnumValues(CollectionServiceType, [CollectionServiceType.DROPOFF_AIRPORT])
        : reduceEnumValues(CollectionServiceType, [
            CollectionServiceType.DROPOFF_AIRPORT,
            CollectionServiceType.COLLECTION,
        ])
}

export const getDeliveryOptions = ({
    isGroupedLaneStatuses,
    originPositioningFtl,
    originPositioningLtl,
}: {
    isGroupedLaneStatuses?: boolean,
    originPositioningFtl?: boolean,
    originPositioningLtl?: boolean,
}) => {
    return (isGroupedLaneStatuses || originPositioningFtl || originPositioningLtl)
        ? DeliveryServiceType
        : reduceEnumValues(DeliveryServiceType, [DeliveryServiceType.DELIVERY_ROAD])
}

export const getValue = (val: boolean) => {
    if (!isNil(val)) {
        return val ? 'Available' : 'Not Available'
    }

    return null
}
